export default view => {
  const {
    name,
    description,
    properties = [],
    customProperties = [],
    filters = [],
    sort = [],
    itemsPerPage,
    active,
    isDefault,
  } = view;

  const selection = properties.reduce((acc, property) => {
    const { key, type, name: heading } = property;
    return [...acc, { key, format: type ?? null, heading }];
  }, []);

  const columns = customProperties.reduce((acc, customProperty) => {
    const { key, type, value, name: heading } = customProperty;
    return [...acc, { key, type, value, heading }];
  }, []);

  const formattedSorting = sort.reduce((acc, sorting) => {
    const { key, direction } = sorting;
    return [...acc, { key, direction }];
  }, []);

  const formattedFilters = filters.reduce((acc, filter) => {
    const { key, operator, value } = filter;

    if (operator === 'between') {
      return [
        ...acc,
        {
          key,
          operator: 'gte',
          value: value[0],
        },
        {
          key,
          operator: 'lte',
          value: value[1],
        },
      ];
    }

    if (operator === 'missing') {
      return [
        ...acc,
        {
          key,
          operator,
          value: [],
        },
      ];
    }

    return [...acc, { key, operator, value }];
  }, []);

  return {
    name,
    description,
    columns,
    filters: formattedFilters,
    selection,
    sort: formattedSorting,
    pagesize: itemsPerPage,
    active,
    is_default: isDefault,
  };
};
